import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomIcon, Widget, WidgetLoader } from "datastake-daf/dist/components";
import Style from "./style";
import { capitalizeAll } from "../../../../helpers/StringHelper";

export default function EntityWidget({
  mod,
  label,
  loading,
  data = {},
  namespace,
  infoSubject = "informationSubjects",
}) {
  const goTo = useNavigate();
  const { t } = useTranslation();
  const disabled = false; //!data.own && !data.acquired && !data.datapoints;

  return (
    <Style className="flex-1">
      <Widget
        title={t(label)}
        className="with-border-header flex-1"
        addedHeader={(
          <>
            <div className="flex-1" />
            <Button
              type="primary"
              disabled={disabled}
              onClick={() => goTo(`/app/${mod}/data-store/${namespace}`)}
            >
              <div className="flex flex-column justify-content-center h-100">
                <CustomIcon name="ArrowUpRight" width={20} height={20} color="white" />
              </div>
            </Button>
          </>
        )}
      >
        {!!loading && <WidgetLoader background="white" />}

        <div className="conf-rows">
          <div className="conf-row">
            <label className="label flex-1">{t('Own Data')}</label>
            <label className="value">{Number((infoSubject === 'informationSubjects' ? data.own : data.datapoints) || 0).toLocaleString('en-us')}</label>
          </div>
          <div className="conf-row">
            <label className="label flex-1">{capitalizeAll(t('DataStore::acquired-data'))}</label>
            <label className="value">{Number((infoSubject === 'informationSubjects' ? data.acquired : data.acquiredDatapoints) || 0).toLocaleString('en-us')}</label>
          </div>
          {/* <div className="conf-row">
            <label className="label flex-1">{capitalizeAll(t('DataStore::data-points'))}</label>
            <label className="value">{Number(data.datapoints || 0).toLocaleString('en-us')}</label>
          </div> */}
        </div>
      </Widget>
    </Style>
  );
}
